import { ExtractRouteParams } from "@CommonUtils/routes";
import type { PogCsvDataset } from "@CommonApi/merchflows/exports/csv/columns";

export const RoutePostMerchflows_merchflowId_ExportsBatch =
  "/merchflows/:merchflowId/exports/batch";

export type ParamsPostMerchflows_merchflowId_ExportsBatch = ExtractRouteParams<
  typeof RoutePostMerchflows_merchflowId_ExportsBatch
>;

export type StorePogExportType = "psaV2" | "csv" | "pdfV2" | "pln";

export type PayloadPostMerchflows_merchflowId_ExportsBatch = {
  overwrite?: boolean;
  columns?: string[];
} & (
  | { type: "csv"; csvDataset?: PogCsvDataset }
  | { type: Exclude<StorePogExportType, "csv">; csvDataset?: never }
) & (
  | {
      // To export selected store pogs
      store_pogs_ids: number[];
      exportAllStorePogExclude?: never;
      approved_store_pogs?: never;
      base_pog_ids?: never;
    }
  | {
      // To export all store pogs
      store_pogs_ids?: never;
      exportAllStorePogExclude: number[];
      approved_store_pogs?: never;
      base_pog_ids?: never;
    }
  | {
      // To export all approved store pogs.
      store_pogs_ids?: never;
      exportAllStorePogExclude?: never;
      approved_store_pogs: boolean;
      base_pog_ids?: never;
    }
  | {
      // To export selected base pogs.
      store_pogs_ids?: never;
      exportAllStorePogExclude?: never;
      approved_store_pogs?: never;
      base_pog_ids: number[];
      csvDataset?: "ranged";
    }
);

export interface ResponsePostMerchflows_merchflowId_ExportsBatch {
  batch_id: number;
  type: StorePogExportType;
  status: "NOT_STARTED" | "IN_PROGRESS" | "DONE" | "ERROR";
  progress?: {
    generated: number;
    total: number;
  };
  url?: string;
}
